import script from "./Order-expand.vue?vue&type=script&setup=true&lang=js"
export * from "./Order-expand.vue?vue&type=script&setup=true&lang=js"

import "./Order-expand.vue?vue&type=style&index=0&id=78cacc0f&lang=less"

const __exports__ = script;

export default __exports__